import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from '@chakra-ui/react'

export const CalendarModal = ({
  title,
  isOpen,
  onClose,
  children,
  onConfirm,
}: any) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={{ base: 'sm', lg: 'md' }}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{children}</ModalBody>

        <ModalFooter>
          <Button mr={3} onClick={onClose}>
            Close
          </Button>
          <Button colorScheme="primary" onClick={onConfirm}>
            Update
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
